import $ from '../tools/Dom';

const openShareWindow = href => {
    const left = (screen.width / 2) - (600 / 2);
    const top = (screen.height / 2) - (600 / 2);
    window.open(href, 'shareWindow', `height=600,width=600, top=${top},left=${left},toolbar=no,menubar=no,scrollbars=no,resizable=no,location=no,directories=no,status=no`);
};

const onClick = e => {
    e.preventDefault();
    const node = e.triggerTarget;
    openShareWindow(node.href);
};

const init = () => {
    $('[data-share-link]').on('click', onClick);
};

export default {
    init
};
